'use client'
import Button from '@/app/components/common/Button'
import Title from '@/app/components/common/Title'
import TranslateString from '@/app/components/common/TranslateString'
import TravelInformationBanner from '@/app/components/TravelInformationBanner'
import { Icons } from '@/app/components/ui/Icons'
import { INPUT, XLG_BREAKPOINT } from '@/app/constants'
import eventBus from '@/app/eventBus'
import { emitSearchHotelsNowGAEvent } from '@/app/ga-event-helpers'
import { PS_EVENTS } from '@/app/ps-events'
import { smoothScrollTo } from '@/app/utils'
import { useMediaQuery } from '@uidotdev/usehooks'
import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import Image from 'next/image'
const TravelInformation = () => {
	const t = useTranslations('Main.travelInfo')
	const isXLG = useMediaQuery(XLG_BREAKPOINT)

	const handleButtonClick = () => {
		emitSearchHotelsNowGAEvent()
		const bookingFormRef = document.querySelector('.booking')
		if (bookingFormRef) {
			smoothScrollTo(bookingFormRef.getBoundingClientRect().top)

			setTimeout(() => {
				eventBus.publish(PS_EVENTS.INPUT_FOCUS, INPUT.LOCATION)
			}, 500)
		} else {
			console.error('Booking form not found')
		}
	}
	return (
		<div className="travel-info flex gap-4">
			<div className="max-w-[454px] flex-col gap-4 hidden xl:flex">
				<div className="flex justify-between gap-4">
					<Image
						src={'/images/slippers.png'}
						width={278}
						height={160}
						alt={'slippers image'}
					/>
					<Image
						src={'/images/logo-big.png'}
						width={160}
						height={160}
						alt={'BHP logo'}
						className="border rounded-4xl border-text-200"
					/>
				</div>
				<div className="bg-gradient-to-b from-[#18CEEF] to-[#026294] rounded-4xl px-11 py-16 min-h-[475px] relative">
					<Title
						level="2"
						color="white"
						size="4xl"
						className="font-extrabold uppercase mb-4 text-center"
					>
						<TranslateString
							i18nKey={'bestPartners'}
							context={'Main.travelInfo'}
						/>
					</Title>
					<div className="text-center text-white font-medium">
						{t('description')}
					</div>
					<Image
						src={'/images/partners-front-logo.png'}
						width={545}
						height={300}
						style={{ height: 'auto' }}
						alt={'Partners logos '}
						className="absolute bottom-0 left-0 right-0 rounded-4xl"
						unoptimized
					/>
				</div>
			</div>
			<div className="grow flex flex-col justify-start gap-4">
				{/* <TravelInformationSlider /> */}
				<TravelInformationBanner />
				<div className="xl:p-8 p-8 px-5 flex flex-col border border-text-200 rounded-4xl">
					<p className="text-text-900 font-extrabold uppercase mb-4 leading-none">
						{t('whyBHP')}
					</p>
					<div className="flex justify-between items-center">
						<div className="flex items-center ">
							<Icons.iconBadge className="me-1.5 shrink-0" />
							<span className="text-xs uppercase text-text-900 font-medium">
								<TranslateString
									i18nKey={'trustedBy'}
									context={'Main.travelInfo'}
								/>
							</span>
						</div>
						<div className="flex items-center">
							<Icons.save className="me-1.5 shrink-0" />
							<span className="text-xs uppercase text-text-900 font-medium">
								<TranslateString
									i18nKey={'compareSave'}
									context={'Main.travelInfo'}
								/>
							</span>
						</div>
						<div className="flex items-center">
							<Icons.priceAlert className="me-1.5 shrink-0" />
							<span className="text-xs uppercase text-text-900 font-medium">
								<TranslateString
									i18nKey={'smartPrice'}
									context={'Main.travelInfo'}
								/>
							</span>
						</div>
						<Button
							id="focus-form-buttom"
							big
							onClick={handleButtonClick}
							bgColor="main"
							textColor="white"
							name="Search hotels now"
							className="font-bold hover:opacity-80 text-xl !bg-gradient-to-r h-14 px-6 w-fit from-main to-[#E1004B] !rounded-full transition-all ease-linear flex items-center justify-center"
						>
							<Icons.iconLens className="mr-3 shrink-0" />
							<span className='inline'>{isXLG
								? t('searchHotelsNow')
								: t('searchHotels')}
							</span>
						</Button>
					</div>
				</div>
			</div>
		</div>
	)
}

export default dynamic(() => Promise.resolve(TravelInformation), { ssr: false })
